// extracted by mini-css-extract-plugin
export var card = "_i2-5";
export var cardSelected = "_i2-4";
export var image = "_i2-3";
export var modal = "_i2-0";
export var modalContent = "_i2-1";
export var table = "_i2-2";